import type { Opt } from '@jet/environment/types/optional';

export type LanguageCode = string;
export type LocalizationFilePath = string;

export interface Bundle {
    manifest: {
        properties?: {
            version: string;
            localizations: Record<LanguageCode, LocalizationFilePath>;
        };
        js?: string;
    };
    // tslint:disable-next-line:no-any
    loadResource(path: string): Promise<Record<string, any>>;
}

export function localizationResourcePath(
    bundle: Bundle,
    languageCode: LanguageCode,
): Opt<string> {
    return bundle.manifest.properties?.localizations[languageCode];
}
